// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l4Ky","button":"styles_button__2V0Nk","buttonActive":"styles_buttonActive__2-bXb"};